import React, { useState } from 'react';
import { Shirt, Plus, Edit2, Trash2, X, ZoomIn } from 'lucide-react';

const WardrobeTab = ({ items, onAdd, onDelete, onEdit }) => {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--space-l)' }}>
        <button
          onClick={onAdd}
          data-testid="add-wardrobe-item-btn"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-s)',
            padding: '10px 16px',
            backgroundColor: 'var(--black)',
            color: 'var(--white)',
            border: 'none',
            fontFamily: 'var(--font-body)',
            fontSize: '0.8125rem',
            cursor: 'pointer'
          }}
        >
          <Plus size={16} />
          Добавить вещь
        </button>
      </div>

      {items.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 'var(--space-xxl)', backgroundColor: 'var(--white)', border: '1px solid var(--soft-gray)' }}>
          <Shirt size={48} style={{ color: 'var(--light-gray)', marginBottom: 'var(--space-l)' }} />
          <p style={{ fontFamily: 'var(--font-display)', fontSize: '1.25rem' }}>Гардероб пуст</p>
        </div>
      ) : (
        <div className="stylist-masonry-grid">
          {items.map((item) => (
            <div
              key={item.id}
              className="stylist-masonry-item"
            >
              <div style={{ position: 'absolute', top: '8px', right: '8px', display: 'flex', gap: '4px', zIndex: 2 }}>
                <button
                  onClick={() => onEdit(item)}
                  className="stylist-item-btn"
                >
                  <Edit2 size={14} style={{ color: 'var(--mid-gray)' }} />
                </button>
                <button
                  onClick={() => onDelete(item.id)}
                  className="stylist-item-btn"
                >
                  <Trash2 size={14} style={{ color: '#ef4444' }} />
                </button>
              </div>
              <div 
                className="stylist-item-image-container"
                onClick={() => setFullscreenImage(item.image_url)}
              >
                <img 
                  src={item.image_url} 
                  alt={item.item_kind} 
                  className="stylist-item-image"
                />
                <div className="stylist-zoom-overlay">
                  <ZoomIn size={24} />
                </div>
              </div>
              <div style={{ padding: 'var(--space-s)' }}>
                <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.8125rem', fontWeight: 500, textTransform: 'capitalize' }}>
                  {item.item_kind}
                </p>
                <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.75rem', color: 'var(--light-gray)' }}>
                  {item.season}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Fullscreen Image Viewer */}
      {fullscreenImage && (
        <div 
          className="stylist-fullscreen-viewer"
          onClick={() => setFullscreenImage(null)}
        >
          <button className="stylist-fullscreen-close">
            <X size={32} />
          </button>
          <img 
            src={fullscreenImage} 
            alt="Full size" 
            className="stylist-fullscreen-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <style>{`
        .stylist-masonry-grid {
          columns: 2;
          column-gap: var(--space-m);
        }
        
        @media (min-width: 600px) {
          .stylist-masonry-grid {
            columns: 3;
          }
        }
        
        @media (min-width: 900px) {
          .stylist-masonry-grid {
            columns: 4;
          }
        }
        
        .stylist-masonry-item {
          break-inside: avoid;
          margin-bottom: var(--space-m);
          background-color: var(--white);
          border: 1px solid var(--soft-gray);
          overflow: hidden;
          position: relative;
          transition: all 300ms ease;
        }
        
        .stylist-masonry-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0,0,0,0.08);
        }
        
        .stylist-item-btn {
          padding: 6px;
          background-color: rgba(255,255,255,0.9);
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 200ms ease;
        }
        
        .stylist-item-btn:hover {
          background-color: rgba(255,255,255,1);
        }
        
        .stylist-item-image-container {
          position: relative;
          cursor: pointer;
          overflow: hidden;
          background-color: var(--cream);
        }
        
        .stylist-item-image {
          width: 100%;
          height: auto;
          display: block;
        }
        
        .stylist-zoom-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 200ms ease;
          color: white;
        }
        
        .stylist-item-image-container:hover .stylist-zoom-overlay {
          opacity: 1;
        }
        
        .stylist-fullscreen-viewer {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: var(--space-l);
        }
        
        .stylist-fullscreen-close {
          position: absolute;
          top: var(--space-l);
          right: var(--space-l);
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: var(--space-s);
        }
        
        .stylist-fullscreen-image {
          max-width: 100%;
          max-height: 90vh;
          object-fit: contain;
        }
      `}</style>
    </div>
  );
};

export default WardrobeTab;
